import { useTrads } from "../../contexts/trads/useTrads";
import { formatDate } from "../../tools/utils";
import type { Transactions } from "../../types/Transaction";
import DemandeListItem from "../Demandes/DemandeListItem";
import './transactions.scss';
function TransactionFondList({transactions}:{transactions:Transactions[]}){
    const {translate}=useTrads();
    return (
        <div className="row transactions">
            <div className="col-6">
                <table className="table caption-top">
                    <caption>{translate('transactions_debits')}</caption>
                    <tbody>
                    {transactions.filter((e)=> e.montant <0 ).map((e:Transactions)=>(
                        <tr key={e.id}> 
                            <td>{!e.regle?<i className="bi bi-hourglass"></i>:null} </td>
                            <td>{formatDate(e.date_creation)}</td>
                            <td> {e.communication} {formatDate(e.date_creation)} </td>
                            <td> {e.demande_id?<DemandeListItem id={e.demande_id}  />:''}</td>
                            <td>{e.montant}</td>
                        </tr>
                    ))}
                    </tbody>
                    <tfoot className="table-light">
                        <tr>
                            <td colSpan={4}></td>
                            <td >
                                {transactions.length?transactions.filter((e)=> e.montant <0 ).reduce((p,v)=>{p.montant+=v.montant;return p}, {montant:0}).montant:0}
                            </td>
                        </tr>
                    </tfoot>
                </table>
        </div>
         <div className="col-6">
            <table className="table caption-top">
                <caption>{translate('transactions_credits')}</caption>
                <tbody>
                    {transactions.filter((e)=> e.montant  >=0 ).map((e:Transactions)=>(
                        <tr key={e.id}> 
                            <td>{!e.regle?<i className="bi bi-hourglass"></i>:null} </td>
                            <td>{formatDate(e.date_creation)}</td>
                            <td> {e.communication}  </td>
                            <td> {e.demande_id?<DemandeListItem id={e.demande_id}  />:''}</td>
                            <td>{e.montant}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot className="table-light">
                    <tr>
                        <td colSpan={4}></td>
                        <td>
                            {transactions.length?transactions.filter((e)=> e.montant  >=0 ).reduce((p,v)=>{p.montant+=v.montant;return p}, {montant:0}).montant:0}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>


        </div>

    )
}
export default TransactionFondList;